import {useState} from 'react';
import {useParams} from 'react-router-dom';

import UserCard from '../../../components/mazraeKit/cards/userCard';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';

import CustomPaginate from '../../../components/mazraeKit/customPaginate';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import Location from '../../../components/mazraeKit/location';
import useGetAllComments from '../../../services/hookService/getAllComments/useGetAllComments';
import useGetDetailShopCard from '../../../services/hookService/getDetailShopCard/useGetDetailShopCard';
import DotsLoading from './../../../components/dotsLoading/index';

const PER_PAGE_SIZE = 7;

const CommentsListing = () => {
  const {guid} = useParams();
  const [currentPage, setcurrentPage] = useState(1);
  const {data: commentsList, isLoading} = useGetAllComments(guid, currentPage);
  const {cardDetailData, isLoading: isLoadingshopCard} = useGetDetailShopCard({
    guid: guid!,
    page_size: PER_PAGE_SIZE,
  });

  return (
    <div className="flex flex-col w-full h-full">
      <CustomHeader
        title="دیدگاه مشتریان"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      {isLoading || isLoadingshopCard ? (
        <div className="flex items-center justify-center h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          <div className="flex flex-col w-full h-full overflow-y-auto ">
            <div className="flex justify-between px-3 mt-4">
              <h3 className="text-md">{cardDetailData?.title || ''}</h3>
              {cardDetailData?.rate !== 0 && cardDetailData?.rate !== null && (
                <div className="flex">
                  <i className="icon-nameStar text-warning-500" />
                  <span className="text-sm">{cardDetailData?.rate}</span>
                </div>
              )}
            </div>
            <div className="px-3 mt-3 mb-3">
              <Location
                state={cardDetailData?.state.name}
                city={cardDetailData?.city.name}
                address={cardDetailData?.address}
                customClassName="border-b pb-3"
              />
            </div>

            <div className="flex flex-col gap-2 px-3">
              {!commentsList && (
                <div className="justify-center w-full d-flex">
                  <p className="text-sm font-Regular">نظری ثبت نشده!</p>
                </div>
              )}
              {commentsList?.results?.map((item, index) => (
                <UserCard
                  rate={item.rate}
                  key={index}
                  cardWrapperClassName="w-full"
                  timeDate={item.created_at}
                  description={item.text}
                  name={item.user ?? item.store.title}
                />
              ))}
            </div>
          </div>
          <div className="mb-7">
            {commentsList?.count && (
              <CustomPaginate
                currentPage={currentPage}
                onPageChange={setcurrentPage}
                totalCount={commentsList?.count}
                perPageSize={PER_PAGE_SIZE}
              />
            )}
          </div>
        </>
      )}
      <MainFooter />
    </div>
  );
};

export default CommentsListing;
